import { registerPlugin } from '@capacitor/core'
const Printer = registerPlugin('Printer')
export default Printer
